/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import './BusBookingDetails.scss';
import { useParams } from 'react-router-dom';
import {
  getBusBookingCancellationDetailsApi,
  getBusBookingDetailsApi,
} from '../../../api/busApi';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import {
  formatDate,
  getNewDate,
  hideHeaderFooter,
  showHeaderFooter,
} from '../../../shared/helper-utils/appUtils';
import {
  DATE_MONTH_YEAR_FORMAT,
  DATE_MONTH_YEAR_VIEW_FORMAT,
  NAVIGATION_ROUTES,
} from '../../../shared/constants/Constants';
import {
  getStringFromLS,
  getUserAgentId,
  getValueFromAppConfig,
} from '../../../shared/helper-utils/localStorage';
import { getUserDetails } from '../../../api/profileApi';
import NumberToWords from '../../../shared/components/NumberToWords';
import { useAppContext } from '../../../saas/AppConfigWrapper';
import { APP_LOGO_URL } from '../../../saas/AppStorageStaticNames';

function BusCreditNote() {
  const { appConfig } = useAppContext();
  const { transactionId } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [bookingDetails, setBookingDetails] = useState({});
  const [cancellationDetails, setCancellationDetails] = useState({});
  const [isSearchDone, setSearchDone] = useState(false);
  const gstChargesRef = useRef(undefined);
  const paxRef = useRef([]);
  const [agent, setAgent] = useState({});

  const getBusBookingDetails = async (txid) => {
    const response = await getBusBookingDetailsApi(txid);
    if (response?.Root?.Status === 'OK') {
      const data = response.Root?.Result?.BusInvoice || {};
      const { BusPassengers } = data;
      if (BusPassengers && BusPassengers !== '') {
        let { BusPassenger } = BusPassengers;
        BusPassenger = Array.isArray(BusPassenger)
          ? BusPassenger
          : [BusPassenger];
        paxRef.current = BusPassenger;
      }

      setBookingDetails(data);
      setSearchDone(true);
    } else {
      setAlert({
        variant: 'error',
        title: 'Bus Bookings Details',
        description: response?.Root?.Message,
      });
    }
  };

  const getBusCancellationDetails = async () => {
    setLoading(true);
    const detailRes = await getUserDetails(getUserAgentId());
    if (detailRes.ApiStatus.Status === 'OK') {
      const user = detailRes.ApiStatus.Result.User;
      setAgent(user);
    }
    const response = await getBusBookingCancellationDetailsApi(transactionId);
    if (response?.Root?.Status === 'OK') {
      const data = response.Root?.Result?.BusCancellation || {};
      if (data.BusPassengers && data.BusPassengers.BusPassenger) {
        data.BusPassengers.BusPassenger = Array.isArray(
          data.BusPassengers.BusPassenger,
        )
          ? data.BusPassengers.BusPassenger
          : [data.BusPassengers.BusPassenger];
      } else {
        data.BusPassengers = { BusPassenger: [] };
        data.BusPassengers.BusPassenger = [
          {
            Title: data.PaxSalutation,
            FirstName: data.PaxFirstName,
            LastName: data.PaxLastName,
            SeatNumber: data.SeatsSelected,
            Age: data.PaxAge,
            Gender: data.PaxGender,
            Status: data.TicketStatus,
          },
        ];
      }
      let sgst = 0;
      let cgst = 0;
      let igst = 0;
      if (data.GstType === 'SGSTCGST') {
        sgst = data.TotalGSTOnCanxCharge / 2;
        cgst = data.TotalGSTOnCanxCharge / 2;
      } else {
        igst = data.TotalGSTOnCanxCharge;
      }
      gstChargesRef.current = {
        sgst,
        cgst,
        igst,
      };
      gstChargesRef.current.serviceCharge = data.CanxChargeOta;
      gstChargesRef.current.total =
        sgst + cgst + igst + gstChargesRef.current.serviceCharge;
      setCancellationDetails(data);
      getBusBookingDetails(data.ReferenceTxid);
    } else {
      setAlert({
        variant: 'error',
        title: 'Bus Cancellation Details',
        description: response?.Root?.Message,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    getBusCancellationDetails();
  }, []);

  useEffect(() => {
    hideHeaderFooter();
    return () => showHeaderFooter();
  }, []);

  const getFullName = (item) => {
    let name = '';
    if (item.Title) name += item.Title;
    if (item.FirstName) name += ` ${item.FirstName}`;
    if (item.LastName) name += ` ${item.LastName}`;
    return name;
  };

  return (
    <div>
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      <div className="print-links d-flex flex-column hide-in-print">
        <a onClick={() => window.print()}>
          <img src="/images/others/print_sidebutton.png" alt="" />
        </a>
        <a href={NAVIGATION_ROUTES.LANDING}>
          <img src="/images/others/home_sidebutton.png" alt="" />
        </a>
      </div>
      {isSearchDone && Object.keys(cancellationDetails).length > 0 && (
        <div
          style={{
            padding: '1rem 10px',
            width: '900px',
            marginInline: 'auto',
            backgroundColor: '#fff',
          }}
          id="ticketheader"
        >
          <div style={{ border: '1px solid #000' }}>
            <div
              style={{
                padding: '10px',
                fontWeight: '600',
                borderBottom: '1px solid #000',
              }}
              className="d-flex justify-content-between align-items-center"
            >
              <div className="flex-1">
                <img
                  src={getStringFromLS(APP_LOGO_URL)}
                  alt={appConfig?.companyName}
                  width="80px"
                />
              </div>
              <div className="flex-1 text-start">Refund Receipt</div>
            </div>
            <div
              style={{
                padding: '4px 10px',
                fontSize: '14px',
                fontWeight: '300',
              }}
              className="d-flex flex-column"
            >
              {getValueFromAppConfig('INVADDRESS')
                .split('<br>')
                .map((d, index) => (
                  <span key={index}>{d}</span>
                ))}
            </div>
            {Object.keys(agent).length > 0 && (
              <div
                className="py-1 fs-12 d-flex px-2"
                style={{ border: '1px solid #000' }}
              >
                <div className="d-flex flex-column flex-1 gap-1">
                  <span>
                    <b>To M/s:</b> {agent.Company}
                    <br />
                  </span>
                  <span>
                    <b>Address: </b>
                    {agent.Address1},{agent.Address2},{agent.City},{agent.State}
                    ,{agent.PinCode},
                    <br />
                  </span>
                  <span>
                    <b>Email: </b>
                    {agent.ContactEmail}
                    <br />
                  </span>
                  <span>
                    <b>Phone: </b>
                    {agent.ContactNumber}
                    <br />
                  </span>
                  <span>
                    <b>GSTN No: </b> {agent.Gst_number}
                  </span>
                </div>
                <div className="d-flex justify-content-between flex-1">
                  <div className="d-flex flex-column gap-1">
                    <span>
                      <b>AgentId: </b> {agent.AgentId}
                    </span>
                    <span>
                      <b>Invoice Date: </b>{' '}
                      {bookingDetails.TxDate.split(' ')[0] &&
                        formatDate(
                          getNewDate(bookingDetails.TxDate.split(' ')[0]),
                          DATE_MONTH_YEAR_FORMAT,
                        )}
                    </span>
                    <span>
                      <b>Invoice No: </b> {bookingDetails.BookingInvNumm}
                    </span>
                    <span>
                      <b>HSN/SAC: </b> 998551
                    </span>
                  </div>
                  <div className="d-flex flex-column gap-1">
                    <span>
                      <b>Credit Note Date: </b>{' '}
                      {cancellationDetails.RefundDate.split(' ')[0] &&
                        formatDate(
                          getNewDate(
                            cancellationDetails.RefundDate.split(' ')[0],
                          ),
                          DATE_MONTH_YEAR_FORMAT,
                        )}
                    </span>
                    <span>
                      <b>Credit Note No: </b>{' '}
                      {bookingDetails.CancellationInvoiceNumber}
                    </span>
                  </div>
                </div>
              </div>
            )}
            <div className="text-center p-1 fs-12 fw-500">
              Category Type : Bus
            </div>
            <div className="mb-2">
              <table className="table-bordered fs-12 w-100 ">
                <thead>
                  <tr>
                    <th colSpan={3}>Bus details</th>
                  </tr>
                  <tr>
                    <th>Journey details</th>
                    <th>Operator Name</th>
                    <th>Bus Type</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {bookingDetails.SourceName} -{' '}
                      {bookingDetails.DestinationName}
                    </td>
                    <td>{bookingDetails.TravelsName}</td>
                    <td>{bookingDetails.BusType}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            {paxRef.current.length > 0 && (
              <div className="mb-2">
                <table className="table-bordered fs-12 w-100 ">
                  <thead>
                    <tr>
                      <th colSpan={4}>Passenger Details</th>
                    </tr>
                    <tr>
                      <th> Name</th>
                      <th>PNR Number</th>
                      <th>Ticket Number</th>
                      <th>Seat no/Seat type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paxRef.current.map((pax, index) => (
                      <tr key={index}>
                        <td style={{ textTransform: 'uppercase' }}>
                          {pax.Title} {pax.FirstName} {pax.LastName}
                        </td>
                        <td>{bookingDetails.OperatorPnr}</td>
                        <td>{bookingDetails.SupplierTicketNumber}</td>
                        <td>
                          {pax.SeatNumber}/{pax.SeatType}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <div className="fs-12 d-flex justify-content-between gap-1 px-2 border-bottom pb-2">
              <div className="d-flex align-items-end">
                <p className="mb-0">
                  <b>Amount in Words : </b>
                  <span className="text-capitalize fw-300">
                    <NumberToWords
                      number={cancellationDetails.RefundAmount.toFixed(2)}
                    />
                  </span>
                </p>
              </div>
              <div className="d-flex justify-content-end">
                <table>
                  <tbody>
                    <tr>
                      <td>[ + ] Basic</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {bookingDetails.TotalBaseFare.toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>[ - ] Cancellation Charges</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {cancellationDetails.OperatorCanxCharge.toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>[ - ] Service Charges</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {cancellationDetails.ServiceTax.toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>[ + ] Commission</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {cancellationDetails.Commission.toFixed(2)}
                      </td>
                    </tr>

                    <tr className="border-bottom">
                      <td>[ - ] TDS</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {cancellationDetails.TDS.toFixed(2)}
                      </td>
                    </tr>
                    <tr className="border-bottom fw-bold">
                      <td>Total Refund Amount (Rs) </td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {cancellationDetails.RefundAmount.toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="p-2 fs-12 fw-600">
              <div className="d-flex justify-content-between">
                <div className="d-flex gap-1 flex-column flex-1">
                  <span>
                    <b>Terms & Conditions: </b>
                  </span>
                  <ul>
                    <li>
                      This is computer generated invoice signature not required.
                    </li>
                    <li>
                      All Cases Disputes are subject to New Delhi jurisdiction.
                    </li>
                    <li>
                      Refunds Cancellations are subject to Supplier&apos;s
                      approval
                    </li>
                    <li>
                      Kindly check all details carefully to avoid unnecessary
                      complications.
                    </li>
                    <li>
                      CHEQUE : Must be drawn in favour of &quot;:{' '}
                      {appConfig?.companyName} &quot;
                    </li>
                    <li>
                      LATE PAYMENT : Interest @ 24% per annum will be charged on
                      all outstanding bills after the due date.
                    </li>
                    <li>
                      All transactions between the Company and the Agency are
                      subject to the Company&apos;s Privacy Policy and Terms and
                      Conditions
                    </li>
                    <li>
                      All invoices and credit notes are confidential and should
                      not be disclosed to third parties without prior written
                      consent from the Company.
                    </li>
                  </ul>
                </div>
                <div className="d-flex flex-column justify-content-end align-items-center mb-3">
                  <p>{getValueFromAppConfig('COMPANYNAME')}</p>
                  <span>Authorised Signature</span>
                </div>
              </div>
              <div
                style={{
                  marginTop: '10px',
                  fontSize: '15px',
                  fontWeight: '600',
                  textAlign: 'center',
                }}
              >
                Bank Name : ICICI BANK | Account no :000705009962 | IFSC
                ICIC0006637 | Branch Connaught Place, New Delhi
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default BusCreditNote;
